import { call, takeLatest, select, put } from 'redux-saga/effects';
import axios from 'axios';
import {
  submitJSONError as submitJSONErrorAction,
  showUILoader,
  hideUILoader,
  setErrorUrl,
  fetchTemplates as fetchTemplatesAction,
  fetchTemplate as fetchTemplateAction,
  setJSONTemplates,
  setJSONEditor,
} from '../store';
import { makeRequest } from './uiApi';
import { makeRequest as makeRequestTemplates } from './api';
import { PayloadAction } from '@reduxjs/toolkit';
import defaultEnvs from '../constants/defaultEnvs';
import jsonConstants from '../constants/jsonConstants';

// declare a request interceptor
axios.interceptors.request.use(
  (config) => {
    // perform a task before the request is sent
    return config;
  },
  (error) => {
    // handle the error
    return Promise.reject(error);
  },
);
const getPlainHeaders = () => {
  return {
    'Content-Type': 'text/plain',
    'Access-Control-Allow-Origin': '*',
    timeout: 3000,
  };
};
const getJsonHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    timeout: 3000,
  };
};

function* submitJSONError({ payload }: PayloadAction<any>) {
  try {
    yield put(showUILoader());
    // @ts-ignore
    const { data } = yield call(makeRequest, {
      url: 'ReportJsonError?session=' + payload['sessionId'],
      method: 'POST',
      data: btoa(payload['errorJson']),
      ...getPlainHeaders(),
    });
    yield put(hideUILoader());
    yield put(setErrorUrl(data));
  } catch (err) {
    console.warn(err);
    yield put(hideUILoader());
  }
}

function* fetchTemplates() {
  try {
    yield put(showUILoader());
    // @ts-ignore
    const { data } = yield call(makeRequestTemplates, {
      url: 'templatesList.json',
      method: 'GET',
      ...getJsonHeaders(),
    });
    yield put(hideUILoader());
    yield put(setJSONTemplates(data));
  } catch (err) {
    console.warn(err);
    yield put(hideUILoader());
  }
}

function* fetchTemplate({ payload: fileName }: PayloadAction<string>) {
  try {
    yield put(showUILoader());
    // @ts-ignore
    const { data } = yield call(makeRequestTemplates, {
      url: fileName,
      method: 'GET',
      ...getJsonHeaders(),
    });
    yield put(hideUILoader());
    yield put(
      setJSONEditor({
        ...data,
        flowcharts: Object.keys(data['flowcharts']).reduce(
          (acc: any, fcName: string) => ({
            ...acc,
            [fcName]: { ...data['flowcharts'][fcName], templateName: fileName },
          }),
          {},
        ),
        templatization: {
          ...data['templatization'],
          environments: (data['templatization']['environments'] && data['templatization']['environments'].length > 0) ? data['templatization']['environments'] : Object.keys(jsonConstants.defaultEnvMap).reduce((envs: { [envId: string]: any }, defaultEnvKey) => { if (jsonConstants[defaultEnvKey as keyof typeof jsonConstants]) { envs[jsonConstants.defaultEnvMap[defaultEnvKey as keyof typeof jsonConstants.defaultEnvMap]] = { ...defaultEnvs[jsonConstants.defaultEnvMap[defaultEnvKey as keyof typeof jsonConstants.defaultEnvMap] as keyof typeof defaultEnvs]} }; return envs; }, {})
        },
      }),
    );
  } catch (err) {
    console.warn(err);
    yield put(hideUILoader());
  }
}

export const uiWatchers = [
  takeLatest(submitJSONErrorAction.type, submitJSONError),
  takeLatest(fetchTemplatesAction.type, fetchTemplates),
  takeLatest(fetchTemplateAction.type, fetchTemplate),
];
